import { AxiosResponse } from 'axios';

import { SFCCBasket } from '../../models/sfcc-basket';
import { addLocaleToBasketUrl } from '../../utilities/add-locale-to-basket-url';
import { sfccSettings, shopHttp } from '../basket-api';

interface CreateBasketFromReferenceBody {
  basket_id: string;
  customer_id: string;
}

export const createBasketFromReference = async (
  basketId: string,
  customerId: string
): Promise<SFCCBasket> => {
  const url = '/baskets/reference';
  const finalUrl = addLocaleToBasketUrl(url, sfccSettings.shopApiLocale);
  const body: CreateBasketFromReferenceBody = {
    basket_id: basketId,
    customer_id: customerId,
  };

  const response = await shopHttp.post<CreateBasketFromReferenceBody, AxiosResponse<SFCCBasket>>(
    finalUrl,
    body
  );

  return response.data;
};
